import { assertNotUndefined } from '@datapad/utilities';
import { SchemaFactory, TreeAlpha } from 'fluid-framework/alpha';
const schemaFactory = new SchemaFactory('datapad.ref');
export class TreeReference extends schemaFactory.object('ref', {
    id: schemaFactory.string,
}) {
    isReferenceTo(node) {
        const id = TreeAlpha.identifier(node);
        return id !== undefined && this.id === id;
    }
    clone() {
        return new TreeReference({ id: this.id });
    }
    static createReferenceToNode(node) {
        const id = assertNotUndefined(TreeAlpha.identifier(node));
        return new TreeReference({ id });
    }
}
export function createReferenceToNode(node) {
    const id = assertNotUndefined(TreeAlpha.identifier(node));
    return new TreeReference({ id });
}
//# sourceMappingURL=TreeReference.js.map